import { FetchStatus, Property, PropertyType } from "../../../../base/types";
import { IAsyncBoundProperties, usePropertyDraftText } from "../../../../base/hooks";
import { useEffect, useState } from "react";

import { Enumeration } from "../../../../base/types/enumeration";
import { IEnumLabelProps } from "./IEnumLabelProps";
import clsx from "clsx";

export const EnumLabelProperties = [
    { id: Property.Value, name: 'Value', type: PropertyType.String },
    { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String },
    { id: Property.Enum, name: 'Enum Values', type: PropertyType.Enumeration },
    { id: Property.ClassNamesExpr, name: 'Enum colors', type: PropertyType.String },
]

export const useEnumLabelProperties = (props: IAsyncBoundProperties) => {
    const { status, result: bindings, error } = props;
    const [properties, setProperties] = useState<IEnumLabelProps>()
    const draftText = usePropertyDraftText({ bindings, property: Property.Value })

    useEffect(() => {
        if (status !== FetchStatus.Success || !bindings)
            return;

        const value = bindings.getValue<string>(Property.Value);
        const enumValue = bindings.getValue<Enumeration>(Property.Enum);
        const title = bindings.getValue<string>(Property.Tooltip);
        const expr = bindings.getValue<string>(Property.ClassNamesExpr);
        
        const label = getEnumLabel(value, enumValue)
        const classNames = getClassNames(value, expr)

        setProperties({ label, title, classNames })
        // eslint-disable-next-line
    }, [bindings, status]);

    const getEnumLabel = (value?: string | number, enumValue?: Enumeration) => {
        if (value === undefined)
            return;

        if (enumValue === undefined) {
            return value.toString();
        } else if (enumValue.type === "string") {
            const item = enumValue.items.find((p) => p.key === value)
            if (item) return item.value
        } else if (enumValue.type === "number") {
            const item = enumValue.items.find((p) => p.key === Number(value))
            if (item) return item.value
        }

        return value.toString();
    }

    const getClassNames = (value?: string, classNamesExpr?: string) => {
        if (!value || !classNamesExpr)
            return "";
        
        try {
            // eslint-disable-next-line
            const classNameExpression = new Function('value', `${classNamesExpr}`).bind(value);
            const classNamesObj = classNameExpression(value);
            return clsx(classNamesObj);
        } catch (error) {
            console.log("error", error);
        }
        
        return "";
    };

    return { status, error, bindings, properties, draftText }
}
